/*
 * @Author: HWD
 * @Date: 2021-10-27 16:16:19
 * @LastEditors: HWD
 * @LastEditTime: 2021-11-11 13:50:47
 * Copyright 2021 © HWD, All Rights Reserved. 
 * @Description: 
 */
import Vue from 'vue'
import Router from 'vue-router'
import MoveCar from '@/components/MoveCar'
//import QrCode from '@/components/QrCode'
import Spread from '@/components/Spread'
import Register from '@/components/Register'

Vue.use(Router)

const router =  new Router({
  mode: 'history',
  routes: [
    // {
    //   path: '/',
    //   redirect: '/movecar/movecar'
    // },
    {
      path: '/movecar/movecar',
      name: 'movecar',
      component: MoveCar
    },
    // {
    //   path: '/qrcode',
    //   name: 'qrcode',
    //   component: QrCode
    // },
    {
      path: '/movecar/spread',
      name: 'spread',
      component: Spread
    },
    {
      path: '/movecar/register',
      name: 'register',
      component: Register
    }
  ]
})

//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
  console.log('a',to);
  console.log('b',from);
  console.log('c',next);
  next();
  //to:将要访问的路径
  //from代表从哪个路径来
  //next是一个函数，表示放行
  //const role = localStorage.getItem('ms_username');
  //const tokenStr = window.sessionStorage.getItem('token');
  // if (to.path !== '/movecar/movecar') {
  //     next('/movecar/movecar');
  // } else {
  //     // 简单的判断IE10及以下不进入富文本编辑器，该组件不兼容
  //     if (navigator.userAgent.indexOf('MSIE') > -1 && to.path === '/editor') {
  //         Vue.prototype.$alert('vue-quill-editor组件不兼容IE10及以下浏览器，请使用更高版本的浏览器查看', '浏览器不兼容通知', {
  //             confirmButtonText: '确定'
  //         });
  //     } else {
  //         next();
  //     }
  // }
});


export default router;
